import * as messageBox from './ui-message-box.js'
import * as buttonSprite from './ui-button-sprite.js'

export default async function procSelect(params) {
    const { app, w, h, cards } = params;

    // Show message
    const text = 'カードを1枚選んでください';
    const mes = messageBox.gen(app, text);
    mes.y = h * 0.1;

    // Split cards
    const splits = [];
    const baseY = h * 0.85;
    await new Promise(resolve => {
        cards.forEach((card, i) => {
            buttonSprite.onClick(card, async () => {
                params.select = {i, card};
                cards.forEach(card => buttonSprite.offClick(card));
                mes.destroy();
                const x = w / 2;
                const y = h * 0.6;
                await anime({targets: card, x, y, rotation: 0, duration: 750, easing: 'linear'}).finished
                resolve();
           });
        });
    });
}
